import {
  convertIosStringToDateDayjs,
  formatToCurrencyType,
} from "helper/common";
import moment from "moment";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
import { DataFormField } from "types/models/input-field-type";

const { COMBO_BOX, DATE_DISABLE, SELECT, INPUT } = FIELD_TYPE;

const revenuesCustomerFields: DataFormField[] = [
  // {
  //   label: "Chọn loại",
  //   type: COMBO_BOX,
  //   name: "loai",
  // },
  // {
  //   label: "Chi nhánh ",
  //   type: SELECT,
  //   options: [
  //     {
  //       value: "alina",
  //       label: "Alina",
  //     },
  //     {
  //       value: "vinmec",
  //       label: "Vinmec",
  //     },
  //   ],
  //   allowClear: true,
  //   name: "chiNhanh",
  // },
  {
    label: "Loại Item",
    type: SELECT,
    options: [
      {
        value: "TH",
        label: "Thuốc",
      },
      {
        value: "KI",
        label: "Kính",
      },
      {
        value: "VTYT",
        label: "Vật tư y tế",
      },
      {
        value: "OTK",
        label: "Othor - K",
      },
    ],
    allowClear: true,
    name: "loaiItem",
  },
  {
    label: "Tên",
    type: INPUT,
    name: "tenItem",
  },
  {
    label: "Người thực hiện",
    type: COMBO_BOX,
    name: "nguoiThucHien",
  },
  {
    label: "Mã KH",
    type: INPUT,
    name: "maKhachHang",
  },
  {
    label: "Tên KH",
    type: INPUT,
    name: "tenKhachHang",
  },
  {
    label: "Loại hình thanh toán",
    type: SELECT,
    name: "loaiHinhThanhToan",
    allowClear: true,
  },
  {
    label: "Thời gian từ",
    type: DATE_DISABLE,
    name: "start",
  },
  {
    label: "Thời gian đến",
    type: DATE_DISABLE,
    name: "end",
  },
];

const revenuesCustomerAllColums: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    fixed: "left",
    width: 40,
    align: "center",
  },
  {
    title: "Thời gian",
    key: "thoiGian",
    dataIndex: "thoiGian",
    align: "center",
    width: 150,
    render: (text) => (text ? moment(text).format(FORMAT_TIME.dateTime) : ""),
  },
  {
    title: "Người thực hiện",
    key: "nguoiThucHien",
    dataIndex: "nguoiThucHien",
    align: "left",
    width: 120,
  },
  {
    title: "Mã khách hàng",
    key: "maKhachHang",
    dataIndex: "maKhachHang",
    align: "center",
    width: 100,
    // render: (text) => formatToCurrencyType(text),
  },
  {
    title: "Tên khách hàng",
    key: "tenKhachHang",
    dataIndex: "tenKhachHang",
    align: "left",
    width: 130,
    // render: (text) => formatToCurrencyType(text),
  },
  {
    title: "Số hóa đơn",
    key: "soHoaDon",
    dataIndex: "soHoaDon",
    align: "center",
    width: 80,
  },
  {
    title: "Loại hình thanh toán",
    key: "loaiHinhThanhToan",
    dataIndex: "loaiHinhThanhToan",
    width: 100,
  },
  {
    title: "Số tiền",
    key: "soTien",
    dataIndex: "soTien",
    width: 120,
    align: "right",
    render: (t) => formatToCurrencyType(t),
  },
];

export { revenuesCustomerFields, revenuesCustomerAllColums };
